import { createFileRoute } from '@tanstack/react-router'

import { PlatformEphemeralJobsPage } from '../../../components/pages/backoffice/platform/platform-ephemeral-jobs-page/platform-ephemeral-jobs-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/ephemeral-jobs')({
  component: () => (
    <PermissionChecker requiredPermissions={['job.runEphemeral']}>
      <PlatformEphemeralJobsPage />
    </PermissionChecker>
  ),
})
